import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Input, Row, Col, Dropdown, Menu, Button, message } from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import placeholderImg from "../../../../src/assets/Images/course1.png";
import usericon from "../../../../src/assets/Images/usericon.png";
import clock from "../../../../src/assets/Images/clock.png";
import arrow from "../../../../src/assets/Images/ArrowUpRight (4).png";
import Filter from "../../../../src/assets/Images/Vector.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import FetchData from "../../../hooks/FetchData";
import moment from "moment";

const Customstyle1 = styled.div`
  .textstyle {
    font-size: 18px;
    font-weight: 400;
    margin-left: 20px;
    margin-bottom: 20px;
    text-align: left;
  }

  .course-list {
    display: flex;
    flex-wrap: wrap;
  }

  .course-card {
    width: 100%;
    height: 448px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
    padding: 10px;
    margin-left: 20px;
    cursor: pointer;
  }

  .course-img {
    width: 100%;
    height: 200px;
    border-radius: 8px;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
  }
  .course-img:hover {
    transform: scale(1.1);
  }
  .hov {
    position: relative;
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 8px;
  }

  .hidden-tag {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    padding: 2px 10px;
    border-radius: 12px;
    background: rgba(31, 36, 59, 0.75);
    color: #fff;
    font-size: 12px;
    font-weight: 500;
  }
  .course-body {
    padding: 15px;
  }

  .course-title {
    font-size: 18px;
    font-weight: 500;
    text-align: left;
  }

  .course-text {
    margin: 10px 0;
    font-size: 14px;
  }

  .btn {
    display: inline-block;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
  }
  .cb {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .view-details {
    display: flex;
    font-weight: 700;
    font-size: 18px;
    align-items: center;
    justify-content: space-between;
  }
  .auth {
    color: #636980;
  }

  .input-style {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .empty-state {
    margin: 40px 20px;
    color: #636980;
  }
`;

function Courselist() {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("");

  useEffect(() => {
    const fetchCourses = async () => {
      if (!userInfo?.clientId) return;
      setLoading(true);
      try {
        const response = await FetchData({
          endPoint: `/course/getcourse/${userInfo.clientId}`,
        });
        // Admin view: every course, including ones hidden from the learner
        // catalog - the admin created them, so they must never vanish here.
        // Hidden ones get a "Hidden" tag on the card instead.
        setCourses(response?.response || []);
      } catch (error) {
        console.error("Error fetching course catalog:", error);
        message.error("Unable to load the course catalog");
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, [userInfo?.clientId]);

  const categories = Array.from(
    new Set(courses.map((c) => c.category).filter(Boolean))
  );

  const filteredCourses = courses.filter((course) => {
    const matchesSearch = !searchText.trim()
      ? true
      : (course.course_name || "").toLowerCase().includes(searchText.trim().toLowerCase());
    const matchesCategory = !category ? true : course.category === category;
    return matchesSearch && matchesCategory;
  });

  const menu = (
    <Menu
      onClick={(e) => setCategory(e.key === "all" ? "" : e.key)}
      items={[
        { key: "all", label: "All Categories" },
        ...categories.map((c) => ({ key: c, label: c })),
      ]}
    />
  );

  return (
    <Customstyle1>
      <div className="textstyle">
        <p>Course List</p>
      </div>
      <Row gutter={12} className="g-3 mb-2">
        <Col>
          <div className="input-style">
            <Input
              style={{
                marginLeft: "20px",
                maxHeight: "34px",
                borderRadius: "24px",
              }}
              placeholder="Search"
              prefix={<SearchOutlined style={{ color: "#636980" }} />}
              className="searchbar-style"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </Col>
        <Col>
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button
              style={{
                height: "34px",
                width: "221px",
                borderRadius: "24px",
              }}
            >
              <img src={Filter} alt="filter" />
              {category || "Select Category"} <DownOutlined className="down" />
            </Button>
          </Dropdown>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <div className="course-list" style={{ marginTop: "20px" }}>
          {!loading && filteredCourses.length === 0 && (
            <p className="empty-state">No courses found.</p>
          )}
          {filteredCourses.map((course) => (
            <Col lg={8} md={12} sm={24} key={course.course_id}>
              <div
                className="course-card"
                onClick={() =>
                  navigate("/viewdetail", { state: { course_id: course.course_id } })
                }
              >
                <div className="hov">
                  {course.hide_courselist && (
                    <span className="hidden-tag" title="Hidden from learners' Course List">
                      Hidden
                    </span>
                  )}
                  <img
                    src={course.course_profile || placeholderImg}
                    alt={course.course_name}
                    className="course-img"
                  />
                </div>
                <div className="course-body">
                  <p className="course-title">{course.course_name}</p>
                  <div className="cb">
                    <div className="course-text">
                      <img src={usericon} alt="author" />{" "}
                    </div>
                    <div className="auth1">{course.conducted_by || "—"}</div>
                  </div>
                  <div className="cb">
                    <div className="course-text">
                      <img src={clock} alt="updated" />{" "}
                    </div>
                    <div>
                      <span className="auth">Last Updated:</span>{" "}
                      {course.updated_at
                        ? moment(course.updated_at).format("Do MMM YYYY")
                        : "—"}
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="view-details pb-2">
                    <div>
                      <p
                        className="btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/viewdetail", {
                            state: { course_id: course.course_id },
                          });
                        }}
                      >
                        View Details
                      </p>
                    </div>
                    <div>
                      <img src={arrow} alt="go" />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </div>
      </Row>
    </Customstyle1>
  );
}

export default Courselist;
